import { useState, useEffect } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/servizi", label: "Servizi" },
  { to: "/impermeabilizzazione-poliurea", label: "Poliurea" },
  { to: "/coibentazione-poliuretano", label: "Poliuretano" },
  { to: "/progetti", label: "Progetti" },
  { to: "/contatti", label: "Contatti" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isHome = pathname === "/";
  // Transparent (over dark hero) only on home before scroll and when mobile menu closed
  const transparent = isHome && !scrolled && !open;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-300 border-b ${
        transparent ? "bg-transparent border-transparent" : "bg-background/85 backdrop-blur-xl border-border"
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <img
            src={transparent ? "/images/ghs-logo-icon-white.png?v=2" : "/images/ghs-logo-icon.png?v=4"}
            alt=""
            width="636"
            height="204"
            className={`h-10 md:h-12 w-auto shrink-0`}
            loading="eager"
          />
          <span className="w-3 h-3 bg-primary block shrink-0" />
          <span className={`font-head font-black text-sm md:text-base tracking-tightest leading-[0.85] flex flex-col ${transparent ? "text-white" : "text-foreground"}`}>
            <span>GREENHOUSE</span>
            <span>SOLUTIONS<span className="text-primary">.</span></span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace(/\//g, "")}`}
              className={({ isActive }) =>
                `font-mono text-xs uppercase tracking-widest whitespace-nowrap transition-colors hover:text-primary ${
                  isActive ? "text-primary" : transparent ? "text-white/85" : "text-foreground/70"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-preventivo"
            onClick={() => navigate("/preventivo")}
            className="hidden sm:inline-flex items-center gap-1.5 bg-primary text-primary-foreground font-mono text-xs uppercase tracking-widest px-5 py-3 hover:bg-foreground transition-colors duration-200"
          >
            Richiedi Preventivo <ArrowUpRight className="w-4 h-4" />
          </button>
          <button
            className={`lg:hidden p-2 ${transparent ? "text-white" : "text-foreground"}`}
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background border-t border-border" data-testid="nav-mobile-menu">
          <div className="px-5 py-6 flex flex-col gap-4">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="font-head text-2xl font-bold tracking-tightest text-foreground"
              >
                {l.label}
              </NavLink>
            ))}
            <button
              onClick={() => { setOpen(false); navigate("/preventivo"); }}
              className="mt-2 bg-primary text-primary-foreground font-mono text-xs uppercase tracking-widest px-5 py-4"
            >
              Richiedi Preventivo
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
